const exportedObject = {
  consultarAfiliadoFarmaCardData: {},
  consultarAfiliadoFarmaCardLoading: false,
  consultarAfiliadoFarmaCardError: null,

  limpiarDatosAfiliadoFarmaCardLoading: false,
};

export default exportedObject;

